import { AltoIcon, H2, ListItem, MdSpacing, Tag } from '@alto/design-system';
import React from 'react';
import { Drawer } from '~web/components/Drawer';
import { Image as ImageComponent } from '~web/components/Image';
import browserIcon from '~web/images/browser-icon_spot-illo@3x.png';
import appAlto from '~web/images/notification@2x.png';

export type Props = {
  readonly onClose: () => void;
  readonly handleAppSelected: () => void;
  readonly handleBrowserSelected: () => void;
};

const GetTheAppDrawer = ({ onClose, handleAppSelected, handleBrowserSelected }: Props) => {
  return (
    <Drawer
      analyticsName="how_to_use_alto"
      onClose={onClose}
      dismissable
    >
      <H2>How do you want to use Alto?</H2>
      <MdSpacing />
      <ListItem
        onPress={handleAppSelected}
        LeftContent={
          <ImageComponent
            alt="Alto App Logo"
            src={appAlto}
            sidebar
          />
        }
        title="Download mobile app"
        tags={
          <Tag
            label="Recommended"
            type="recommended"
          />
        }
        tagPlacement="bottom"
        RightContent={
          <AltoIcon
            name="chevronright"
            type="grey"
          />
        }
      />
      <ListItem
        onPress={handleBrowserSelected}
        LeftContent={
          <ImageComponent
            alt="Browser Logo"
            src={browserIcon}
            sidebar
          />
        }
        title="Continue on web"
        RightContent={
          <AltoIcon
            name="chevronright"
            type="grey"
          />
        }
      />
    </Drawer>
  );
};
export default GetTheAppDrawer;
